export default __webpack_public_path__ + "static/alan-5ed6adc83836e0e6643691fded470004.jpg";